import { useCombobox } from 'downshift';
import { trackSearchSubmit, trackAutocompleteSelect, trackRecommendationSelect, } from '../utils/tracking';
let idCounter = 0;
const useDownShift = ({ setQuery, items, onSubmit, cioClient, previousQuery = '', ...rest }) => useCombobox({
    id: `cio-autocomplete-${idCounter++}`,
    items,
    itemToString: (item) => item?.value || '',
    onSelectedItemChange({ selectedItem }) {
        if (selectedItem) {
            if (selectedItem?.value) {
                if (onSubmit)
                    onSubmit({ item: selectedItem, originalQuery: previousQuery });
                try {
                    if (selectedItem?.section === 'Search Suggestions') {
                        setQuery(selectedItem.value || '');
                        trackSearchSubmit(cioClient, selectedItem.value, {
                            originalQuery: previousQuery,
                        });
                    }
                    // Autocomplete Select tracking
                    // Recommendation Select tracking
                    if (selectedItem.podId && selectedItem.data?.id && selectedItem.strategy) {
                        const recommendationData = {
                            itemName: selectedItem.value,
                            itemId: selectedItem.data.id,
                            variationId: selectedItem.data.variation_id,
                            podId: selectedItem.podId,
                            strategyId: selectedItem.strategy.id,
                            section: selectedItem.section,
                            resultId: selectedItem.result_id,
                        };
                        trackRecommendationSelect(cioClient, recommendationData);
                        // Select tracking for all other Constructor sections:
                        // (ie: Search Suggestions, Products, Custom Cio sections, etc)
                        // This does not apply to custom user defined sections that aren't part of Constructor index
                    }
                    else if (selectedItem.result_id) {
                        const selectData = {
                            originalQuery: previousQuery,
                            section: selectedItem.section,
                            itemId: selectedItem.data?.id,
                        };
                        trackAutocompleteSelect(cioClient, selectedItem.value, selectData);
                    }
                }
                catch (error) {
                    // eslint-disable-next-line no-console
                    console.log(error);
                }
            }
        }
    },
    stateReducer: (state, actionAndChanges) => {
        const { type, changes } = actionAndChanges;
        // Override dropdown close on blur
        if (type === useCombobox.stateChangeTypes.InputBlur) {
            return { ...changes, isOpen: state.isOpen };
        }
        return changes;
    },
    ...rest,
});
export default useDownShift;
